import axios from 'axios'
import BlogApp from 'apps/Blog'
import { safePromise } from 'utils/universal/safePromise'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'locales/es/common'
import blogMessages from 'locales/es/blog'
import commonEnMessages from 'locales/en/common'
import blogEnMessages from 'locales/en/blog'

export default BlogApp

export const getStaticProps = async ({ locale }) => {
  const commonStaticProps = await getCommonStaticProps()

  const messages = locale === 'es'
    ? { ...commonMessages, ...blogMessages }
    : { ...commonEnMessages, ...blogEnMessages }

  const url = `${process.env.NEXT_PUBLIC_API_ROOT}/posts/`
  const { result } = await safePromise(axios(url))

  return {
    props: {
      titleMeta: 'BLOG_TITLE',
      descriptionMeta: 'BLOG_DESCRIPTION',
      messages,
      ...commonStaticProps,
      headerProps: {
        activeIndex: 3,
        className: 'bg-gray',
      },
      posts: result?.data ?? [],
    },
  }
}
